import { CatalogExportFilters } from "../types/export-format.types";

const MAX_GET_EXPORT_TERM_LENGTH = 1800;
const MAX_GET_EXPORT_EAN_COUNT = 40;

export function catalogExportRequiresPost(
    filters?: CatalogExportFilters | null,
): boolean {
    const term = filters?.term?.trim() ?? "";
    if (!term) {
        return false;
    }
    if (term.length > MAX_GET_EXPORT_TERM_LENGTH) {
        return true;
    }
    const eanCount = term.split(",").map((part) => part.trim()).filter(Boolean)
        .length;
    return eanCount > MAX_GET_EXPORT_EAN_COUNT;
}
